export const NAMING_PATTERN = /^[\p{L}0-9\s()_@!¿?¡"'%&#.,-]+$/u;
